import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-900 text-white py-12 px-4" data-id="element-35">
      <div className="max-w-7xl mx-auto" data-id="element-36">
        <div className="text-center mb-8" data-id="element-37">
          <h3 className="text-2xl font-bold text-red-500 mb-2" data-id="element-38">
            🎨 Mega Pacote Artes Visuais
          </h3>
          <p className="text-gray-400" data-id="element-39">
            Recursos educativos para professores apaixonados.
          </p>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center" data-id="element-40">
          <p className="text-gray-400 text-sm mb-2" data-id="element-41">
            © 2026 Todos os direitos reservados.
          </p>
          <p className="text-gray-500 text-sm" data-id="element-42">
            Feito com ❤️ para a comunidade de Artes Visuais do Brasil.
          </p>
        </div>
      </div>
    </footer>;
}